import { Color } from '@pixi/color';
import { Container, Graphics } from 'pixi.js-legacy';

import { themingInstance } from '@exchange/libs/utils/theming/src';

export default class PriceLine extends Container {
  private graphics = new Graphics();

  constructor({ lineX, lineY }: { lineX: number; lineY: number }) {
    super();
    this.x = lineX;
    this.y = lineY;
    this.draw();
    this.addChild(this.graphics);
  }

  private draw(): void {
    this.graphics.beginFill(new Color(themingInstance.getColor('--v-theme-text-primary')).toNumber());
    this.graphics.drawRect(0, 0, 6, 1); // dash between number and line pattern

    for (let i = 0; i < 200; i += 1) {
      // generate pattern
      this.graphics.drawRect(i * 5, 0, 1, 1);
    }

    this.graphics.endFill();
  }
}
